import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';

export default function BlogPage() {
  const { serviceId } = useParams();

  // Updated Database with your official descriptions
  const servicesData = {
    "airport-transfers": {
      title: "AIRPORT TRANSFERS",
      img: "/assets/service1.jpeg",
      readTime: "5 min read",
      date: "June 3, 2026",
      desc: "​Navigating major airport terminals can be challenging, but your ground transportation shouldn’t be. Globe Reliance Transport delivers premium, reliable, and highly efficient airport transfer solutions designed specifically for corporate groups, event delegates, and private business travelers.",
      extraContent: (
        <>
          <p>​We provide seamless connectivity to and from all major aviation hubs in the Emirates, including Dubai International Airport (DXB), Al Maktoum International (DWC), and Abu Dhabi International Airport (AUH).</p>
          <h4 className="fw-bold mt-4 mb-3" style={{ color: '#002d62' }}>The Globe Reliance Advantage</h4>
          <ul>
            <li><strong>Real-Time Flight Tracking:</strong> We monitor your flight schedule continuously. Whether your flight arrives early or faces a delay, your chauffeur will be synchronized with your actual landing time.</li>
            <li><strong>Meet & Greet Excellence:</strong> Experience a stress-free arrival. Our professional drivers await you at the designated arrivals area with personalized signage, ready to assist with your luggage and escort you to your vehicle.</li>
            <li><strong>Tailored Fleet Modules:</strong> From the modern, high-capacity corporate buses featured in 1000061657.jpg to sleek executive vehicles, our fleet offers the perfect configuration for any group size or comfort preference.</li>
            <li><strong>Experienced Chauffeurs:</strong> Our drivers are highly trained, multilingual, and possess an intimate knowledge of the UAE’s highway networks, ensuring a safe, smooth, and punctual journey.</li>
            <li><strong>Transparent, Fixed Pricing:</strong> We offer competitive, all-inclusive corporate rates with no hidden fees or unexpected peak-hour surcharges, making budget management simple.</li>
          </ul>
        </>
      )
    },
  "corporate-shuttles": {
  title: "CORPORATE SHUTTLES",
  img: "/assets/servise.jpeg",
  readTime: "7 min read",
  date: "May 28, 2026",
  desc: "Globe Reliance understands the critical role reliable and professional transportation plays in the corporate world. In today’s fast-paced business environment, punctuality, efficiency, and employee well-being are vital to operational success.",
  extraContent: (
    <>
      <p>Whether you need to connect remote business parks, transport daily commuters, or manage smooth travel between multiple corporate offices, our customized shuttle programs are designed to keep your workforce moving seamlessly.</p>
      
      <h4 className="fw-bold mt-4 mb-3" style={{ color: '#002d62' }}>Custom Transport Programs Built for Your Business</h4>
      <p>We don't believe in a one-size-fits-all approach. Globe Reliance partners with your logistics and HR teams to design optimized transit routes, strategic pickup schedules, and ideal fleet configurations that align with your company’s exact operational hours.</p>
      
      <div className="mt-4">
        <p><strong>Daily Employee Commutes:</strong> Reduce the stress of daily traffic for your team. Our recurring daily shuttle services ensure your workforce arrives at the office relaxed, focused, and on time.</p>
        
        <p><strong>Inter-Office Connectivity:</strong> Keep your departments integrated. We run scheduled, reliable loops between headquarters, branch offices, and manufacturing hubs across the UAE.</p>
        
        <p><strong>Metro & Transit Hub Links:</strong> Bridge the first-mile, last-mile gap. Our shuttles seamlessly ferry employees from major metro stations or central transit hubs directly to your facility's doorstep.</p>
        
        <p><strong>Modern, Premium Fleet:</strong> Our luxury buses and corporate vans are fully equipped with modern amenities, offering a safe, clean, and highly comfortable environment for your staff.</p>
      </div>
    </>
  )
},
"hotel-fleet-tours": {
  title: "HOTEL FLEET TOURS",
  img: "/assets/hotel-staff-transport-C4h6dwgy.png",
  readTime: "6 min read",
  date: "May 22, 2026",
  desc: "Globe Reliance offers a dedicated Pickup and Drop-Back facility for hotel staff on all routes throughout the city. The hospitality industry never sleeps, and maintaining world-class guest services requires a workforce that is punctual and reliably transported.",
  extraContent: (
    <>
      <p>We partner with the UAE's leading hotels and luxury resorts to provide structured, round-the-clock transport modules tailored specifically to the unique, shift-based nature of hospitality operations.</p>
      
      <h4 className="fw-bold mt-4 mb-3" style={{ color: '#002d62' }}>Tailored Transport Solutions for Your Hospitality Team</h4>
      <p>Whether handling the early morning kitchen brigade, front-of-house staff, or late-night housekeeping teams, Globe Reliance ensures smooth transitions between shifts with absolute precision, ensuring your operations remain flawless 24/7.</p>
      
      <div className="mt-4">
        <p><strong>24/7 Shift Alignment:</strong> Hospitality operates on strict timelines. Our transport modules run smoothly across 24-hour cycles, ensuring seamless handovers for morning, evening, and night shifts without delay.</p>
        
        <p><strong>Comprehensive City-Wide Routes:</strong> We design efficient pickup and drop-back grids that cover major residential areas and transit hubs, guaranteeing your staff a direct and safe commute to and from the property.</p>
        
        <p><strong>Professional & Welcoming Standard:</strong> We understand that hospitality starts from within. Providing a comfortable, air-conditioned, and premium commuting experience reflects your commitment to staff well-being.</p>
        
        <p><strong>Optimized Multi-Property Logistics:</strong> For hotel groups managing multiple properties or staff accommodation centers, we coordinate cross-property routes to maximize fleet efficiency and minimize operational overhead.</p>
      </div>
    </>
  )
},
   "school-transport": {
  title: "SCHOOL TRANSPORT",
  img: "/assets/service.jpeg",
  readTime: "5 min read",
  date: "May 15, 2026",
  desc: "Globe Reliance offers special discounts for city and group tours, and transport passes are also available. We understand that transporting students requires the highest level of care, responsibility, and precision.",
  extraContent: (
    <>
      <p>Our specialized educational transport modules are designed to give schools, parents, and administrative teams complete peace of mind by ensuring students commute in a safe, secure, and highly organized environment.</p>
      
      <h4 className="fw-bold mt-4 mb-3" style={{ color: '#002d62' }}>Comprehensive Travel Services for Educational Institutions</h4>
      <p>From daily morning and afternoon school runs to specialized extracurricular travel, Globe Reliance provides a complete mobility framework tailored to the academic calendar.</p>
      
      <ul className="mt-3">
        <li className="mb-2"><strong>Daily Commutes & Flexible Transport Passes:</strong> We offer structured routing for regular student commutes. With our convenient school transport passes, tracking and managing daily student ridership is simplified for both parents and administration.</li>
        
        <li className="mb-2"><strong>Special Discounts for City & Group Tours:</strong> Learning extends beyond the classroom. Globe Reliance provides substantial discounts on safe, comfortable group transport for educational field trips, cultural city tours, and inter-school sports competitions.</li>
        
        <li className="mb-2"><strong>Dedicated & Attentive Supervision:</strong> Our school transport service features professional onboard attendants who carefully coordinate student boarding, verify passes, and monitor safety protocols throughout the entire journey.</li>
        
        <li className="mb-2"><strong>Modern, High-Safety Fleet:</strong> Our specialized school buses are equipped with essential modern safety features, compliant with regional transport regulations, and meticulously maintained to guarantee the highest standard of transit security.</li>
      </ul>
    </>
  )
},
    "intercity-rentals": {
      title: "INTERCITY RENTALS",
      img: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&q=80&w=600",
      readTime: "4 min read",
      date: "May 10, 2026",
      desc: "Seamless intercity transport solutions connecting Abu Dhabi, Dubai, Sharjah, and other emirates with luxury coaches and trained professional drivers.",
      extraContent: <p>Our intercity modules cater to long-distance corporate relocation, cross-emirate business meets, and group excursions with absolute focus on absolute highway safety and comfort alignment.</p>
    },
    "event-transportation": {
      title: "EVENT TRANSPORTATION",
      img: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&q=80&w=600",
      readTime: "8 min read",
      date: "May 05, 2026",
      desc: "Comprehensive logistics management for large exhibitions, weddings, corporate events, and VIP passenger routing across prime UAE venues.",
      extraContent: <p>From ground coordination to routing timetables, we align our high-capacity luxury fleet with event organizers to ensure seamless guest arrivals and departures.</p>
    }
  };

  const currentServiceKey = serviceId || "airport-transfers";
  const currentService = servicesData[currentServiceKey] || servicesData["airport-transfers"];

  const otherServices = Object.keys(servicesData)
    .filter(key => key !== currentServiceKey)
    .map(key => ({ slug: key, ...servicesData[key] }));

  return (
    <div className='mt-5' style={{ backgroundColor: '#f8fafd', minHeight: '100vh' }}>
      <br/>
         <br/>
       <br/>
      <div className="mt-5" style={{ backgroundColor: '#002d62', padding: '50px 0', textAlign: 'center' }} className="text-white">
        <Container>
          <p className="small mb-2">Home &gt; Services &gt; {currentService.title}</p>
          <h1 className="fw-bold" style={{ letterSpacing: '1px' }}>{currentService.title}</h1>
          <p className="opacity-75">Professional passenger transport modules configured for customized alignments.</p>
        </Container>
      </div>

      <Container className="py-5">
        <Row className="g-4">
          
          <Col lg={8}>
            <Card className="border-0 shadow-sm mb-4 overflow-hidden rounded-3">
              <div style={{ width: '100%', height: '400px', overflow: 'hidden' }}>
                <Card.Img 
                  variant="top" 
                  src={currentService.img} 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <Card.Body className="p-4">
                <span className="badge bg-primary mb-3">FEATURED SERVICE</span>
                <h2 style={{ color: '#0056b3' }} className="fw-bold mb-2">
                  {currentService.title} Solutions in UAE
                </h2>
                <p className="text-muted small mb-4">{currentService.date} • {currentService.readTime}</p>
                <hr />
                
                {/* Dynamically displaying content based on title/slug */}
                <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: '#444444', fontWeight: '500' }}>
                  {currentService.desc}
                </p>
                
                <div style={{ fontSize: '1.05rem', lineHeight: '1.7', color: '#444444' }}>
                  {currentService.extraContent}
                </div>

                <p className="mt-4" style={{ fontSize: '1.05rem', lineHeight: '1.7', color: '#444444' }}>
                  Globe Reliance Passenger Transport provides premium and structurally verified route options across the UAE. Our vehicles are fully equipped with advanced navigation and premium tracking modules to monitor timelines, assuring ultimate punctuality and excellence in execution.
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4}>
            {/* Widget 1: Newsletter */}
            <Card className="border-0 shadow-sm p-4 text-white mb-4 rounded-3" style={{ backgroundColor: '#0056b3' }}>
              <h5 className="fw-bold">Stay Updated</h5>
              <p className="small opacity-90">Subscribe to our newsletter and never miss our latest updates and fleet additions.</p>
              <Form>
                <Form.Control type="email" placeholder="Enter your email address" className="mb-2 py-2 border-0" />
                <Button variant="warning" className="w-100 fw-bold text-white py-2" style={{ backgroundColor: '#ff7f50', border: 'none' }}>
                  Subscribe Now ↗
                </Button>
              </Form>
            </Card>

            <h5 className="fw-bold mb-3 mt-4" style={{ color: '#002d62' }}>Popular Posts</h5>
            
            <div className="d-flex flex-column gap-3">
              {otherServices.map((srv, idx) => (
                <Link to={`/blog/${srv.slug}`} key={idx} className="text-decoration-none">
                  <Card className="border-0 shadow-sm overflow-hidden h-100 rounded-3 bg-white service-sidebar-card" style={{ transition: 'transform 0.2s' }}>
                    <Row className="g-0 align-items-center">
                      <Col xs={4} style={{ height: '85px', overflow: 'hidden' }}>
                        <img 
                          src={srv.img} 
                          alt={srv.title} 
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                        />
                      </Col>
                      <Col xs={8}>
                        <Card.Body className="p-2 ps-3">
                          <h6 className="fw-bold mb-1 text-truncate-2" style={{ fontSize: '0.85rem', color: '#111111', lineHeight: '1.3' }}>
                            {srv.title}: Complete Guide 2026
                          </h6>
                          <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                            {srv.date} • {srv.readTime}
                          </span>
                        </Card.Body>
                      </Col>
                    </Row>
                  </Card>
                </Link>
              ))}
            </div>
          </Col>
        </Row>
      </Container>

      <style>{`
        .text-truncate-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;  
          overflow: hidden;
        }
        .service-sidebar-card:hover {
          transform: translateX(4px);
          box-shadow: 0 8px 20px rgba(0,86,179,0.1) !important;
        }
      `}</style>
    </div>
  );
}






